
import {
  buildPageHead,
  buildAnalyticsMeta,
  buildHeadScripts,
} from '@/helpers/pageSeo'
import { convertHtmlToText } from '~/helpers/convertHtmlToText';

export default {
  name: 'IndexPage',
  middleware: ['returnUrl', 'onlyRedirectProject'],
  head() {
    const locale = this.$i18n.locale
    const contents = this.$store.state.settings.contents[locale]
    const description = convertHtmlToText(contents.home.banner.overview)
    const { title, meta, link } = buildPageHead(this, {
      title: contents.seo.home.title,
      description: description,
      image: contents.home?.banner?.imagePath,
      canonicalHref: contents.seo.home.url,
    })
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      title,
      meta: [...meta, ...buildAnalyticsMeta(this)],
      link,
      script: buildHeadScripts(this),
      __dangerouslyDisableSanitizers: ['script'],
    }
  },
  async fetch({ store, app }) {
    const currency = store.getters['user/getUserIP'].currency
    const filter = {
      page: 1,
      search: '',
      limit: 12,
      type: 5,
      currency: store.getters['user/getUserIP'].currency,
      hasBlog: store.state.settings?.components?.includes('Blogs') || false,
      isRequest: true, //store.state.settings?.components?.includes('Basic') || false,
    }
    const requestArray = []
    if (filter.hasBlog)
      requestArray.push(
        store.dispatch('blogs/GET_BLOGS', { ...filter, categoryId: -1 })
      )
    if (store.state.settings?.components?.includes('PopularProducts'))
      requestArray.push(
        store.dispatch('popularProducts/GET_POPULAR_PRODUCTS', {
          currency,
          lang: app.i18n.locale,
        })
      )

    await Promise.all([...requestArray])
  },
}
